export const isSoundTurnedOn = (): boolean => {
	return JSON.parse( window.localStorage.getItem( 'ggwp-sound-status' ) || 'true' );
};